import { render, staticRenderFns } from "./add-task-drawer.vue?vue&type=template&id=91622cf8&"
import script from "./add-task-drawer.vue?vue&type=script&lang=ts&"
export * from "./add-task-drawer.vue?vue&type=script&lang=ts&"
import style0 from "./add-task-drawer.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports